<template lang='pug'>
.static-top
  .static-headline
    i.icon-chat
    h1.static-textHeadline {{ info.title }}
  .static-subheadline
    p.text--16.color--black60 {{ info.content }}
  .static-image1
    i.static-promo
</template>
<script>
export default {
  props: {
    info: Object
  }
}
</script>
